export default __webpack_public_path__ + "static/media/smilies05.b6efac69.png";